const colors = {
    primary: {
        light: '#00B0AE',
        main: '#00B0AE',
        dark: '#009A97',
        contrastText: '#FFF',
    },
    
    error: {
        light: '#ffa8a5',
        main: '#FB7676',
        dark: '#c4454a',
        contrastText: '#FFF',
    },

    commons: {
        fontColor: '#969696',
        gray: '#E5E5E5',
        darkGray: '#666666',
        gray2: '#EEEEEE',
        gray3: '#969696',
        gray4: '#E5E5E3',
        gray5: '#707070',
        grayLight: '#F9F9F9',
        blue: '#52D5FC',
        yellow: '#FBBF6D',
        red: '#FB7676',
        darkRed: '#e27575',
        waikawaGrey: '#657496',
        brown: '#BC9292',
        purple: '#9B69FF',
        black: '#0B0E19',
        green: "#00B0AE",
        white: '#FFFFFF',
        placeholderColor: '#C9C9C9',
    },

    status: {
        confirmado: "#00B0AE",
        aguardando: "#FBBF6D",
        cancelado: "#FB6D6D",
        atendido:  "#9B69FF",
        agendado: "#6DC7FB",
        bloqueado: "#666666"
    }
};


export default colors;
